const angular = require('angular');
const moment = require("moment");
var app = angular.module('learn-controllers');

/**
 * Edit Multi Session Workshops Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {MultiSessionWorkshops} MultiSessionWorkshops injected to gain access to the MultiSessionWorkshops resource
 * @argument {Workshops} Workshops injected to gain access to the Workshops resource
 * @argument {AccessHelper} AccessHelper injected to gain access to the AccessHelper factory
 */


app.controller('editMultiSessionWorkshop', ['Application', 'Authorization', 'MultiSessionWorkshops', 'Workshops', 'AccessHelper', '$translate', '$location', '$scope', '$timeout', function (Application, Authorization, MultiSessionWorkshops, Workshops, AccessHelper, $translate, $location, $scope, $timeout) {
  var self = this;
  var routeParameters = Application.navigation.getRouteParameters();
  var guessedTz = moment.tz.guess();
  self.features = Application.features.flags();

  self.info = {
    currentTab: 'details',
    user: '',
    loading: false,
    newWorkshop: !routeParameters.id,
    initializing: true,
    addingSessions: false,
    editingSessions: false,
    promptPublish: false,
    updateIndicator: false,
    displayLeaveConfirm: false
  }

  self.allowance = {
    createMultiSessionWorkshop: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'workshops_create']], ['admin', 'creator', 'collaborator']),
    editMultiSessionWorkshop: AccessHelper.isAllowed(['admin', 'content', 'all_edit'], [['admin', 'content', 'workshops_edit'], ['admin', 'content', 'my_content_edit']], ['admin', 'creator', 'collaborator']),
    add_partner: self.features.enable_partners && AccessHelper.isAllowed(['admin', 'content'], null, ['admin']),
  };

  self.company = Authorization.getAuthToken().company;
  self.workshopDynamic = self.company && self.company.workshops_dynamic_messaging;
  self.createFirstMessage = 'Please add at least one session or create this workshop prior to adding notifications.';


  if ((!self.info.newWorkshop && !self.allowance.editMultiSessionWorkshop) || (self.info.newWorkshop && !self.allowance.createMultiSessionWorkshop) || !self.company.feature_flags.enable_multisession_workshops) {
    Application.navigation.goTo('/explore');
    return;
  }

  // MAPPERS -------------

  self.categories = {
    linked_category: [],
    mapToLinkedCategory: function() {
      self.categories.linked_category = self.workshop.categories;
    },
    mapToCategories: function() {
      self.workshop.categories = self.categories.linked_category;
      var body = {categories: self.workshop.categories};
      self.comms.update(body);
    }
  }


  self.certPreview = {
    certificate: false,
    certificate_data: [{
        name: 'hide_completion',
        value: 'false'
      }],
    title: '',
    alt_title: '',
    mapToCertPreview: function() {
      self.certPreview.certificate = self.workshop.enableCompletionCertificate;
      self.certPreview.certificate_data[0].value = self.workshop.hideCertificateCompletionDate;
      self.certPreview.alt_title = self.workshop.certificateTitle;
      self.certPreview.title = self.workshop.name;
    }
  }

  self.images = {
    banner_image: '',
    image: '',
    cover_justification: '',
    featured_justification: '',
    mapToEditImages: function() {
      self.images.banner_image = self.workshop.bannerImage;
      self.images.image = self.workshop.coverImage;
      self.images.cover_justification = self.workshop.coverJustification;
      self.images.featured_justification = self.workshop.featuredJustification;
    },
    mapToMSWImages: function() {
      self.workshop.bannerImage = self.images.banner_image;
      self.workshop.coverImage = self.images.image;
      self.workshop.featuredJustification = self.images.featured_justification;
      self.workshop.coverJustification = self.images.cover_justification

      var body = {
        bannerImage: self.workshop.bannerImage,
        coverImage: self.workshop.coverImage,
        coverJustification: self.workshop.coverJustification,
        featuredJustification: self.workshop.featuredJustification
      }
      self.comms.update(body);
    }
  }

  // allows us to use the existing ratings-configuration component with our
  // flattened, camelcase workshop object by mapping to the expected data shape and field names
  self.ratings = {
    rating_configuration: {
        allow_rating: false,
        allow_feedback: false,
        notify_feedback_only: false,
        allow_edits: false,
        show_users_rating: false,
        total_value: 5,
        messaging: {
          individuals: [],
          slack_channels: []
        }
    },
    mapToRatingConfig: function() {
      self.ratings.rating_configuration.allow_rating = self.workshop.enableRatings;
      self.ratings.rating_configuration.allow_feedback = self.workshop.enableFeedback;
      self.ratings.rating_configuration.notify_feedback_only = self.workshop.notifyFeedbackOnly;
      self.ratings.rating_configuration.allow_edits = self.workshop.enableEdits;
      self.ratings.rating_configuration.show_users_rating = self.workshop.displayRating;
      self.ratings.rating_configuration.messaging.individuals = self.workshop.individuals;
      self.ratings.rating_configuration.messaging.slack_channels = self.workshop.slackChannels;
    },
    mapToMSWorkshop: function() {
      self.workshop.enableRatings = self.ratings.rating_configuration.allow_rating;
      self.workshop.enableFeedback = self.ratings.rating_configuration.allow_feedback;
      self.workshop.notifyFeedbackOnly = self.ratings.rating_configuration.notify_feedback_only;
      self.workshop.enableEdits = self.ratings.rating_configuration.allow_edits;
      self.workshop.displayRating = self.ratings.rating_configuration.show_users_rating;
      self.workshop.individuals = self.ratings.rating_configuration.messaging.individuals;
      self.workshop.slackChannels = self.ratings.rating_configuration.messaging.slack_channels;

      const body = {
        enableRatings: self.workshop.enableRatings,
        enableFeedback: self.workshop.enableFeedback,
        notifyFeedbackOnly: self.workshop.notifyFeedbackOnly,
        enableEdits: self.workshop.enableEdits,
        displayRating: self.workshop.displayRating,
        individuals: self.workshop.individuals,
        slackChannels: self.workshop.slackChannels
      }

      self.comms.update(body);
    }
  }

  // Allows us to use the existing content-privacy component with our
  // simplified segmentation array by mapping to the expected data shape
  self.privacy = {
    types: {
      privacy_locations: [],
      privacy_departments: [],
      privacy_teams: [],
      privacy_org_levels: [],
      privacy_grades: [],
      privacy_groups: [],
    },
    categoryTypes: {
      privacy_locations: 'location',
      privacy_departments: 'department',
      privacy_teams: 'team',
      privacy_org_levels: 'org_level',
      privacy_grades: 'grade',
      privacy_groups: 'group'
    },
    mapToArray: function() {
      var array = [];
      for (var type in self.privacy.types) {
        var categoryType = self.privacy.categoryTypes[type];
        if (Array.isArray(self.privacy.types[type])) {
          self.privacy.types[type].forEach(function (id) {
            var category = {type: categoryType, id: id};
            array.push(category);
          })
        } else if (type === "private") {
          self.workshop.isPrivate = self.privacy.types[type];
        }
      }
      self.workshop.segmentation = array;
      var body = {
        segmentation: self.workshop.segmentation,
        isPrivate: self.workshop.isPrivate
      }
      self.comms.update(body);
    },
    mapToTypes: function() {
      for (var category of self.workshop.segmentation) {
        if (category.type === 'location') {
          self.privacy.types.privacy_locations.push(category.id);
        } else if (category.type === 'department') {
          self.privacy.types.privacy_departments.push(category.id);
        } else if (category.type === 'team') {
          self.privacy.types.privacy_teams.push(category.id);
        } else if (category.type === 'org_level') {
          self.privacy.types.privacy_org_levels.push(category.id);
        } else if (category.type === 'grade') {
          self.privacy.types.privacy_grades.push(category.id);
        } else if (category.type === 'group') {
          self.privacy.types.privacy_groups.push(category.id);
        }
      }
      self.privacy.types.private = self.workshop.isPrivate;
      self.privacy.types._id = self.workshop.id;
    }
  }

  // MAPPERS END ----------------

  self.authtoken = Authorization.getAuthToken();
  self.user = Authorization.getAuthToken().user;

  var locationChange = $scope.$on('$locationChangeStart', function(event) {
    // Allow the route change to progress when workshop is already created and is auto updating
    if (self.workshop.id) {
      self.info.denied = true;
      return;
    }
    // Otherwise, halt the route change and question the action
    self.info.path = {};
    self.info.path.targetPath = Application.navigation.getPath();
    self.info.path.targetSearch = Application.navigation.getUrlParameters();
    self.info.path.targetHash = Application.navigation.getHash();
    event.preventDefault();
    self.info.displayLeaveConfirm = true;

    // If "Leave Page" is chosen without saving
    self.onLocationChange = function() {
      locationChange();
      $location.path(self.info.path.targetPath).search(self.info.path.targetSearch).hash(self.info.path.targetHash);
      return;
    };

    // If "Save and leave page" is chosen
    self.onLocationChangeSave = function() {
      self.info.loading = true;
      MultiSessionWorkshops.create({}, self.workshop).$promise
      .then(function(results) {
        self.info.loading = false;
        self.info.newWorkshop = false;
        self.info.denied = true;
        locationChange();
        $location.path(self.info.path.targetPath).search(self.info.path.targetSearch).hash(self.info.path.targetHash);
      }).catch(function(error) {
        self.info.loading = false;
        self.info.displayLeaveConfirm = false;
        if (error.data && error.data.status === 401 && error.data.message) {
          Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
        }
        console.log('error creating draft: ', error);
      });
    };
  });

  self.workshop = {
    id: undefined,
    companyId: self.company._id,
    creatorId: self.user._id,
    firstName: '',
    lastName: '',
    email: '',
    hideContent: false,
    categories: [],
    segmentation: [],
    collaborators: [],
    tags: [],
    enableRatings: false,
    enableComments: false,
    enableFeedback: false,
    enableEdits: false,
    displayRating: false,
    notifyFeedbackOnly: false,
    isPrivate: false,
    individuals: [],
    slack_channels: [],
    approvalRequired: false,
    archived: false,
    name: '',
    description: '',
    bannerImage: '',
    coverImage: '',
    enableCompletionCertificate: false,
    certificateTitle: '',
    hideCertificateCompletionDate: null,
    relatedWorkshops: [],
    coverJustification: '',
    featuredJustification: '',
    registrationDisabled: false,
    autoPopulateFromWaitlist: false,
    notes: '',
    sessions: [],
    type: 'freeform',
    cohorts: [],
    published: false,
  };

  self.showCollaborators = false;
  self.typeChoiceTooltipCopy = '';

  self.onTitleChange = function (title) {
    self.workshop.name = title;
  }

  self.relatedChange = function(items) {
    self.workshop.relatedWorkshops = items.filter((value) => !!value._id);
    self.comms.blurSave('relatedWorkshops', self.workshop.relatedWorkshops);
  };

  self.comms = {
    loading: false,
    requiredFields: ['title', 'description', 'type'],
    create: function() {
      if (self.workshop && self.workshop.id) {
        self.info.newWorkshop = false;
      }
      self.info.loading = true;
      MultiSessionWorkshops.create(self.workshop).$promise
        .then(function (workshop) {
          self.workshop.id = workshop.id;
          $location.path('/edit/multi-session-workshops/' + workshop.id);
          self.info.loading = false;
          Application.messaging.addMessage({type: 'success', duration: 5, text: 'Multi Session Workshop created!'});      
        }).catch(function (error) {
        self.info.loading = false;
        if (error.data && error.data.message) {
          Application.messaging.addMessage({type: 'error', duration: 5, text: error.data.message});
        }
        // handle error
        console.error('error creating workshop: ', error);
      });
    },
    blurSave: function(field, value) {
      var body = {};
      body[field] = value;
      self.comms.update(body);
    },
    update: function(body) {
      if (!self.workshop.id) {
        return;
      }
      MultiSessionWorkshops.update({subresource: self.workshop.id.toString()}, body).$promise.then(function(id) {
        Application.messaging.addMessage({type: 'success', duration: 3, text: 'Multi Session Workshop updated!'});
      }).catch(function(error) {
        console.error('ERROR updating MSW: ', error);
        Application.messaging.addMessage({type: 'error', duration: 5, text: error.data.message})
      });
    },
    requestPublish() {
      if (!self.workshop.sessions.length) {
        Application.messaging.addMessage({type: 'error', duration: 5, text: 'Please add sessions before publishing.'});
        return;
      }
      if (!self.workshop.coverImage || !self.workshop.bannerImage) {
        Application.messaging.addMessage({type: 'error', duration: 5, text: 'Please add images before publishing.'});
        return;
      }
      if (self.workshop.type === 'cohort' && (!self.workshop.cohorts.length || !this.validateCohortInstances())) {
        Application.messaging.addMessage({type: 'error', duration: 5, text: 'Please add and assign all cohorts before publishing.'});
        return;
      }
      self.info.promptPublish = true;
    },
    publish: function() {
      self.info.loading = true;
      self.workshop.published = true;
      MultiSessionWorkshops.update({subresource: self.workshop.id.toString()}, {published: self.workshop.published}).$promise.then(function() {
          Application.messaging.addMessage({type: 'success', duration: 5, text: 'The workshop ' + self.workshop.name + ' was published.'});
          self.workshop.published = true;
          self.instances.setPublishedCohorts();
          self.info.loading = false;
      }).catch(function(error) {
        self.info.loading = false;
        self.workshop.published = false;
        if (error.data && error.data.message) {
          Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
        } else {
          Application.messaging.addMessage({type: 'error', text: 'Unable to save the workshop.', duration: 5});
        }
      });
      self.info.promptPublish = false;
    },
    validateCohortInstances: function() {
      // validates every cohort has an instance for every session
      for (const cohortId in self.cohortInstances) {
        for (const sessionId in self.cohortInstances[cohortId]) {
          if (!self.cohortInstances[cohortId][sessionId].value) {
            return false;
          }
        }
      }
      return true;
    }
  }

  self.messaging = {
    published: function() {
      Application.messaging.addMessage({type: 'info', text: 'This workshop has already been published', duration: 5});
    }
  }

  self.sessions = {
    addNewSessions: function() {
      if (self.info.newWorkshop) {
        MultiSessionWorkshops.create({}, self.workshop).$promise.then(function(workshop) {
          self.workshop.id = workshop.id;
          Application.navigation.goTo('/edit/multi-session-workshops/' + self.workshop.id + '/session');
        })
      } else {
        Application.navigation.goTo('/edit/multi-session-workshops/' + self.workshop.id + '/session');
      }
    },
    edit: function(id) {
      Application.navigation.goTo('/edit/multi-session-workshops/' + self.workshop.id + '/session/' + id);
    },
    deleteActiveSession: function() {
      MultiSessionWorkshops.deleteSession({subresource: self.workshop.id, sessionid: this.activeSessionId}).$promise.then(function(data) {
        Application.messaging.addMessage({type: 'success', text: 'Session has been successfully deleted', duration: 5});
        MultiSessionWorkshops.findOne({subresource: self.workshop.id}).$promise.then(function(updatedMsw) {
          self.workshop = updatedMsw;
        })
      })
      .catch(function(err) {
        Application.messaging.addMessage({type: 'error', text: 'Unable to delete session', duration: 5});
      })
      this.cancelDelete();
    },
    showDeleteBox: false,
    activeSessionId: '',
    activeSessionName: '',
    requestDelete: function(id, name) {
      this.activeSessionId = id;
      this.activeSessionName = name;
      this.showDeleteBox = true;
    },
    cancelDelete: function() {
      this.showDeleteBox = false;
      this.activeSessionId = '';
      this.activeSessionName = '';
    }
  }

  self.instances = {
    setPublishedCohorts: function() {
      let savedCohorts = [];
      self.workshop.cohorts.forEach(cohort => {
        console.log(cohort.instanceIds.length)
        if (cohort.instanceIds.length === self.workshop.sessions.length) {
          savedCohorts.push(cohort.id);
        }
      })
      return savedCohorts;
    },
    saveInstancesToCohort: function() {
      for (const cohort in self.cohortInstances) {
        let instanceIds = [];
        for (const session in self.cohortInstances[cohort]) {
          if (self.cohortInstances[cohort][session].value) {
            instanceIds.push(self.cohortInstances[cohort][session].value)
          }
        }
        const foundCohort = self.workshop.cohorts.find(searchedCohort => searchedCohort.id === cohort);
        foundCohort.instanceIds = instanceIds;
      }
      self.instances.saveCohorts();
    },
    saveCohorts: async function() {
      const createdCohorts = self.workshop.cohorts.map(cohort => cohort.id);
      try {
        const updatedId = await MultiSessionWorkshops.update({subresource: self.workshop.id.toString()}, {cohorts: self.workshop.cohorts}).$promise;
        const msw = await MultiSessionWorkshops.findOne({subresource: self.workshop.id.toString()}).$promise;
        self.workshop.cohorts = msw.cohorts;
        if (!self.workshop.cohorts.length) {
          return;
        }
        if (msw.published) {
          self.publishedCohorts = self.instances.setPublishedCohorts();
        }
        self.cohortInstances = self.instances.mapToCohorts();
        const newestCreated = msw.cohorts.at(-1); 
        if (!createdCohorts.includes(newestCreated.id)) {
          return newestCreated.id;
        }
        $scope.$apply();
        return;
      } catch (error) {
        console.log(error);
        if (error.data.message === "Cohort instanceIds must be unique") {
          Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.multi_session_workshop.cohort_date_error']});
          $scope.$apply();
          return;
        }
        Application.messaging.addMessage({type: 'error', duration: 5, text: `Unable to save cohort: ${error.data.message}`});
        $scope.$apply();
      }  
    },
    mapToCohorts: function() {
      // returns: {
      //   cohortId: {
      //       sessionId: {name: instance.name, value: instance.id},
      //       sessionId: {name: instance.name, value: instance.id}
      //   }
      // }
      const cohorts = {};
      self.workshop.cohorts.forEach(cohort => {
        cohorts[cohort.id] = {};
        self.workshop.sessions.forEach(session => {
          cohorts[cohort.id][session.id] = {};
          session.instances.forEach(instance => {
            if (cohort.instanceIds.includes(instance.id)) {
              cohorts[cohort.id][session.id] = {name: moment(instance.start).format('dddd, MMMM D, YYYY (h:mma z)'), value: instance.id}
            }
          })
        })
      })
      return cohorts;
    },
  };
  
  self.matchWidths = function(){
    var widthArr = [];
    var elms = document.querySelectorAll('.js-matchwidth');
    if (elms.length > 0){
      for (var i = 0; i < elms.length; i++){
        var width = parseInt(elms[i].clientWidth);
        widthArr.push(width);
      };
      for (var i = 0; i < elms.length; i++){
        elms[i].style.width = (Math.max(...widthArr) + 1) + "px";
      };
    }
  };

  self.navigation = {
    directory: {
      'details': {
        next: 'sessions',
        previous: null,
        required: function () {
          var missing = [];
          if (!self.workshop.name) {
            missing.push('title');
          }
          if (!self.workshop.description) {
            missing.push('description');
          }
          if (!self.workshop.type) {
            missing.push('type');
          }
          if (missing.length) {
            return missing;
          }
          return null;
        }
      },
      'sessions': {
        next: 'images',
        previous: 'details',
        required: null
      },
      'images': {
        next: 'categories',
        previous: 'sessions',
        required: null
      },
      'categories': {
        next: 'settings',
        previous: 'images',
        required: null
      },
      'settings': {
        next: 'preview',
        previous: 'categories',
        required: null
      },
      'preview': {
        next: null,
        previous: 'settings',
        required: null
      }
    },
    next: function (option) {
      option = option || this.directory[self.info.currentTab].next;
      if (!option || !this.directory[option]) {
        return;
      }
      for (var key in this.directory) {
        if (option === key) {
          self.info.currentTab = option;
          if (option !== 'preview') {
            self.specialCloseLast = option;
          }
          $timeout(function () {
            window.scrollTo(0, 0);
            if (option === 'sessions') {
              self.matchWidths();
            }
          }, 5);
          return;
        }
        if (this.directory[key].required) {
          var missing = this.directory[key].required();
        }
        if (missing && missing.length) {
          var message = 'The following fields are required: ';
          missing.forEach(function (item, index) {
            message += item;
            if (index === (missing.length - 1)) {
              message += '.';
              return;
            }
            message += ', ';
          });
          Application.messaging.addMessage({type: 'error', duration: 6, text: message});
          return;
        }
      }
    },
    previous: function (option) { // TODO should a navigation button be implemented? (not used in normal workshop creation)
      option = option || this.directory[self.info.currentTab].previous;
      if (!option || !this.directory[option]) {
        return;
      }
      self.info.currentTab = option;
    },
    specialClose: function() {
      self.info.currentTab = self.navigation.specialCloseLast ? self.navigation.specialCloseLast : 'settings';
    },
    specialCloseLast: 'settings',
    sessionListPositionChange: function(session, index, direction) {
      const initial = index;
      const sign = direction === 'up' ? -1 : 1;

      for (const [i, selectedSession] of self.workshop.sessions.entries()) {
        if (i === initial + sign) {
          const temp = self.workshop.sessions[i];
          self.workshop.sessions[i] = session;
          self.workshop.sessions[initial] = temp;
          self.cohortInstances = self.instances.mapToCohorts();
          self.comms.update({'sessionOrder': self.workshop.sessions.map(session => session.id)});
          return;
        }
      }
    }
  };


  self.certificate = {
    showPreview: false,
    closePreview: function() {
      self.certificate.showPreview = false;
    },
    mockCompletedDate: new Date(),
    blurSave: function(field, value) {
      self.certPreview.mapToCertPreview();
      self.comms.blurSave(field, value);
    }
  }

  self.partners = {
    partnerPermission: 'tenant',
    changePermission: (permission) => {
      self.partners.partnerPermission = permission;
      self.comms.blurSave('partnerPermissions', permission);
    }
  }

  self.initialize = function () {
    self.info.initializing = true;
    if (self.user.role !== 'admin' && self.user.role !== 'creator' && !self.user.is_collaborator) {
      Application.navigation.goTo('/explore');
      return;
    }
    self.onTitleChange(self.workshop.name);

    if (!self.info.newWorkshop) {
      self.workshop.id = routeParameters.id;
      MultiSessionWorkshops.findOne({subresource: self.workshop.id}).$promise.then(function(msw) {
        if ((msw.companyId !== self.authtoken.company._id) || (msw.collaborators && self.user.is_collaborator && msw.collaborators.length && msw.collaborators.indexOf(self.user._id) === -1)) {
          self.editSaved = true;
          Application.navigation.goToHome();
          return;
        }
        self.workshop = msw;
        // Remove duplicated related workshops in existing data.
        msw.relatedWorkshops = msw.relatedWorkshops.filter((value, index, arr) => arr.indexOf(value) === index);
        self.privacy.mapToTypes();
        self.ratings.mapToRatingConfig();
        self.categories.mapToLinkedCategory();
        self.images.mapToEditImages();
        self.certPreview.mapToCertPreview();
        self.showCollaborators = self.workshop.collaborators.length ? true : false;
        self.cohortInstances = self.instances.mapToCohorts();
        if (msw.published) {
          self.publishedCohorts = self.instances.setPublishedCohorts();
        }
        self.info.initializing = false;
        if (msw.partnerPermissions) {
          self.partners.partnerPermission = msw.partnerPermissions;
        }
      });
    }
    // Sets tab to sessions when coming back from publishing a session then resets trackState
    var state = Application.trackState.get();
    self.info.currentTab = state && state.startTab ? state.startTab : 'details';
    Application.trackState.set({});

    if (self.info.newWorkshop) {
      self.info.initializing = false;
    }
  };

  $translate([
    'edit.multi_session_workshop.cohort_date_error'
  ]).then(function(translations){
    self.translations = translations;
    self.initialize();
  })

}]);

